import React, { useState } from "react"

const PartnersLast12Months = ({
    company
}) => {
  const [count, setCount] = useState(false)
  const [loading, setLoading] = useState(false)

  const loadData = async () => {
    setLoading(true)
    const response = await fetch(`/admin/companies/${company.slug}/last_12_month_partners`)
    const responseJson = await response.json()
    setCount(responseJson.count)
    setLoading(false)
  }

  return <>
    {!loading && !count && <a onClick={() => loadData()}>load data</a>}
    {loading && !count && <>loading...</>}
    {!loading && count && <>{count}</>}
  </>
}

export default PartnersLast12Months
